import smartSuggestions from './smartsuggestions';

window.smartPak = window.smartPak || {};
window.smartPak.smartSuggestions = smartSuggestions;

smartSuggestions.init();